module.exports = __webpack_public_path__ + "static/about-profile-constantinez-3dd0b8b0ef21cb5b40f77a5e178ebe04.png";